<template>
    <div>
        <div v-loading="uploadLoading">
            <el-upload
                drag
                action
                :http-request="uploadDoc"
                ref="upload"
                :show-file-list="false"
                :file-list="fileList"
                :disabled="uploadLoading"
                accept=".doc, .docx, .txt"
                :on-change="onChange">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击选择文件</em></div>
                <div slot="tip" class="el-upload__tip"><div class="color-danger">请上传文档，马上为您检测，<i class="el-icon-warning"></i>注意：只能上传Word、Text文档。</div></div>
            </el-upload>
        </div>

        
        <div class="page-list-box">
            <div class="page-group-title">
                <span>检测列表</span> <el-button type="text" icon="el-icon-refresh" @click="getDataList">刷新</el-button>
            </div>
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="name" label="文件名" show-overflow-tooltip min-width="150"></el-table-column>
                <el-table-column prop="createUserName" label="检测人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createTime" label="检测时间" min-width="150"></el-table-column>
                <el-table-column prop="isChecked" label="情绪检测状态" width="100">
                    <template slot-scope="{row} = scope">
                        <span v-if="row.isChecked == 1">已检测</span>
                        <el-popover
                            v-if="row.isChecked == 0"
                            placement="top"
                            title="检测中"
                            width="200"
                            trigger="hover"
                            content="请耐心等待检测完成后，再来查看检测结果。">
                            <span slot="reference" class="color-warning">检测中</span>
                        </el-popover>
                    </template>
                </el-table-column>
				<el-table-column prop="isChecked" label="敏感词检测状态" width="120">
				    <template slot-scope="{row} = scope">
				        <span v-if="row.isEmotionCheck == 1">已检测</span>
				        <el-popover
				            v-if="row.isEmotionCheck == 0"
				            placement="top"
				            title="检测中"
				            width="200"
				            trigger="hover"
				            content="请耐心等待检测完成后，再来查看检测结果。">
				            <span slot="reference" class="color-warning">检测中</span>
				        </el-popover>
				    </template>
				</el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="{row} = scope">
                        <el-button
                            v-if="$utils.have('/document/result') && row.isChecked == 1"
                            type="text"
                            size="small"
                            @click="$refs.result.show(row.id)"
                            >敏感词检测结果</el-button
                        >
						<el-button
						    v-if="$utils.have('/document/result') && row.isEmotionCheck == 1"
						    type="text"
						    size="small"
						    @click="$refs.feeling.show(row.id)"
						    >情绪检测结果</el-button
						>
                    </template>
                </el-table-column>
            </el-table>
        </div>   
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <result ref="result"></result>
		<feeling ref="feeling"></feeling>
    </div>
</template>

<script>
import {uploadFileTmp} from '@/assets/js/commonApi.js';
import Result from './components/result.vue';
import Feeling from './components/feeling.vue';
const defaultParams = {
    pageNo:1
}
export default {
    components: {
        Result,Feeling
    },
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: 1,
                pageSize: this.$pageSizes[0],
            },
            listLoading: true,
            uploadLoading: false,
            fileList: []
        }   
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/document/list",
                method: "POST",
                params: {
                    ...this.params,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
                    this.data = null;
					this.dataList = [];
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        // 上传文件
        async uploadDoc(req){
            const formData = new FormData();
            formData.append('file', req.file);

            this.uploadLoading = true;

            let filePath;
            const res = await uploadFileTmp(formData).catch(err => {
                this.$message({message: err.message, type: 'error'});
            });
            const{state,msg,result} = res.data;
            if (state == 1 && result) {
                filePath = result.url;
            }else{
                this.$message.error(msg || '上传失败');
            }

            this.$request({
                url:'/document/check',
                method: 'post',
                params:{
                    path:filePath,
                    fileName: req.file.name
                }
            })
                .then(res => {
                    const{state,msg} = res.data;
                    if (state == 1) {
                        this.getDataList()
                    }else{
                        this.$message.error(msg || '请求失败');
                    }
                })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
                .finally(() => {
                    this.uploadLoading = false;
                });
        },
        onChange(file){
            if( file ){
                this.fileList = [{...file}]
            }
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger, 
::v-deep .el-upload{
    width: 100%;
    height: 120px;
    .el-icon-upload{
        margin: 15px 0;
        font-size: 40px;
        line-height: 40px;
    }
}
</style>